import React from 'react';
import { useTranslation } from 'react-i18next';
import './index.scss';

const Forbidden: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="d-error-page forbidden">
      <i className="ri-error-warning-line ri-48px text-warning"></i>
      <h2>403</h2>
      <h3>{t('common.errorMessages.forbiddenPage.forbidden')}</h3>
      <p>{t('common.errorMessages.forbiddenPage.message')}</p>
    </div>
  );
};

export default Forbidden;
